<!--首页模块二-->
<template>
  <div style="font-family: Alibaba">
    <!--产品展示-->
    <div class="boxs_content">
      <div class="index_title">
        <h1>{{ cnNameTwo }}</h1>
        <h6>{{ enNameTwo }}</h6>
      </div>
      <el-carousel indicator-position="outside" trigger="click">
        <el-carousel-item class="carousel_item" v-for="item in homeTwoVo.slice(0, 6)" :key="item.id">
          <a href="#" class='card_box' @click='handleProjectDetail(item.id)'>
            <el-image
              alt="Image Description"
              style="width: 100%"
              v-if='item.fullPathUrl != null'
              :src='item.fullPathUrl'></el-image>
            <h2>{{ item.title }}</h2>
          </a>
        </el-carousel-item>
      </el-carousel>
    </div>
  </div>
</template>
<script>
import { findEnNameOne, findHomeTwo, findProjectOne } from '@/api/zh'

export default {
  created () {
  },
  data () {
    return {
      enNameTwo: '',
      cnNameTwo: '',
      homeTwoVo: [],
      fit: 'cover',
      url: require('@assets/images/index/chanping.png'),
      url1: require('@assets/images/index/chanping1.png'),
      url2: require('@assets/images/index/chanping2.png')
    }
  },
  mounted () {
    this.selectHTwo()
    this.selectProjectOne()
  },
  methods: {
    /** 查询英文名称 */
    selectEnName (cnEnNameId) {
      let that = this
      findEnNameOne(cnEnNameId).then(res => {
        let data = res.data
        that.enNameTwo = data.enName
        that.cnNameTwo = data.cnName
      })
    },
    async selectProjectOne () {
      let that = this
      await findProjectOne(0).then(res => {
        that.homeTwoVo = res.data
      })
    },
    async selectHTwo () {
      let that = this
      await findHomeTwo().then(res => {
        if (res.data.cnEnNameId !== null) {
          that.selectEnName(res.data.cnEnNameId)
        }
      })
    },
    handleTwoClick (item) {},
    /** 详情 */
    handleProjectDetail: function (id) {
      this.$router.push({
        path: '/caseDetails',
        query: {
          projectId: id
        }
      })
    }

  }
}
</script>
<style scoped>
</style>
